(() => {
  const APP38_VARIANT_IDS = new Set(['56626093359429', '56936270430533']);
  const MINIMUM_QUANTITY = 4;

  const isApp38Variant = (value) => APP38_VARIANT_IDS.has(String(value || ''));

  const selectedVariantId = (form) => {
    const variantField = form.querySelector('[name="id"]');
    return variantField ? variantField.value : '';
  };

  const prepareProductForm = (form) => {
    const app38 = isApp38Variant(selectedVariantId(form));
    let quantity = form.querySelector('[name="quantity"]');
    const injectedQuantity = form.querySelector('[data-app38-injected-quantity]');

    if (!app38) {
      injectedQuantity?.remove();
      return;
    }

    if (!quantity) {
      quantity = document.createElement('input');
      quantity.type = 'hidden';
      quantity.name = 'quantity';
      quantity.dataset.app38InjectedQuantity = 'true';
      form.appendChild(quantity);
    }

    const minimum = String(MINIMUM_QUANTITY);
    const quantityValue = String(Math.max(Number(quantity.value) || 0, MINIMUM_QUANTITY));

    if (quantity.value !== quantityValue) quantity.value = quantityValue;
    if (quantity.min !== minimum) quantity.min = minimum;
    if (quantity.dataset.min !== minimum) quantity.dataset.min = minimum;
  };

  const prepareCartInput = (input) => {
    if (!isApp38Variant(input.dataset.quantityVariantId)) return;

    const minimum = String(MINIMUM_QUANTITY);
    if (input.dataset.min !== minimum) input.dataset.min = minimum;
    const quantity = Number(input.value);
    if (quantity > 0 && quantity < MINIMUM_QUANTITY) {
      input.value = String(MINIMUM_QUANTITY);
    }
  };

  const preparePage = (root = document) => {
    if (root instanceof HTMLFormElement && root.matches('form[action*="/cart/add"]')) {
      prepareProductForm(root);
    }

    if (root instanceof HTMLInputElement && root.matches('[data-quantity-variant-id]')) {
      prepareCartInput(root);
    }

    root.querySelectorAll('form[action*="/cart/add"]').forEach(prepareProductForm);
    root.querySelectorAll('[data-quantity-variant-id]').forEach(prepareCartInput);
  };

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (form instanceof HTMLFormElement && form.matches('form[action*="/cart/add"]')) {
      prepareProductForm(form);
    }
  }, true);

  document.addEventListener('change', (event) => {
    const target = event.target;
    if (!(target instanceof HTMLInputElement || target instanceof HTMLSelectElement)) return;

    const productForm = target.closest('form[action*="/cart/add"]');
    if (productForm) prepareProductForm(productForm);

    if (target.matches('[data-quantity-variant-id]')) prepareCartInput(target);
  }, true);

  let prepareQueued = false;

  const queuePreparePage = () => {
    if (prepareQueued) return;

    prepareQueued = true;
    requestAnimationFrame(() => {
      prepareQueued = false;
      preparePage();
    });
  };

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.addedNodes.length > 0) {
        queuePreparePage();
        return;
      }
    }
  });

  const start = () => {
    preparePage();
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
